import styled from 'styled-components';

export default styled.p`
    font-size: ${({theme}) => theme.fontSize.s};
`;
